import React from 'react';
import logComponent from '../../common/logComponent';
import './TooltipInformation.css';

export default function TooltipInformation({ description, isVisible }) {
  if (logComponent('TooltipInformation')) { console.debug('TooltipInformation rendered'); }

  return (
    <div className={'Tooltip-Information' + (isVisible ? ' Tooltip-Information--show' : '')} >
      <svg className="Tooltip-Information__connector" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 13">
        <polygon points="0,12 12,0 24,12" />
        <polygon points="0,13 12,1 24,13" stroke="none" />
      </svg>

      <p className="Tooltip-Information__body">{description} </p>
    </div>
  );
}
